/**
 * @author: ritesh.dabral
 * 
 * This page includes constants for action types
 */

 export const UPDATE_CLICKED_IMAGE_URL = 'UPDATE_CLICKED_IMAGE_URL';

 export const UPDATE_IMAGE_FILE_DATA = 'UPDATE_IMAGE_FILE_DATA';